import React, { useRef, useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import useWindowSize from '../ultils/useWindowSize'

const useStyles = makeStyles({
  fullHeight: {
    height: '100%',
  },
  chartWrapper: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    height: '100%',
  },
})

const ChartWrapper = ({
  Chart,
  initProps,
  updateProps,
  margin,
  useToggle = false,
  useBrush = false,
  useZoom = false,
  brushProps = null,
  zoomProps = null,
  toggleProps = null,
  sizeTrigger = null,
}) => {
  const classes = useStyles()
  const chartArea = useRef(null)
  const [chart, setChart] = useState(null)
  const [chartSet, setChartSet] = useState(null)
  const { width } = useWindowSize()

  // init + update
  useEffect(() => {
    if (!chart) {
      setChart(new Chart(chartArea.current, initProps))
    } else if (chartSet) {
      chart.update(updateProps)
    }
  }, [chart, chartSet, updateProps])

  // screen size
  useEffect(() => {
    if (chartArea && chart) {
      const { offsetWidth, offsetHeight } = chartArea.current.parentElement
      chart.setDimensions(offsetWidth, offsetHeight, margin)
      setChartSet(true)
    }
  }, [chartArea, chart, width, sizeTrigger])

  // zoom changed
  useEffect(() => {
    if (chartSet && useZoom && zoomProps) {
      chart.zoomed(zoomProps)
    }
  }, [chart, chartSet, useZoom, zoomProps])

  // brush changed
  useEffect(() => {
    if (chartSet && useBrush && brushProps) {
      chart.brushed(brushProps)
    }
  }, [chart, chartSet, useBrush, brushProps])

  // toogle changed
  useEffect(() => {
    if (chartSet && useToggle && toggleProps) {
      chart.toggleUpdate(toggleProps)
    }
  }, [chart, chartSet, useToggle])

  return (
    <div className={classes.fullHeight}>
      <div className={classes.chartWrapper} ref={chartArea} />
    </div>
  )
}

export default ChartWrapper
